"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttestationIssuer = void 0;
const protocol_core_1 = require("@moojo/protocol-core");
const data_chunk_codec_1 = require("../codec/data-chunk-codec");
const make_user_id_1 = require("./make-user-id");
/**
 * A facility for issuing attestations.
 */
class AttestationIssuer {
    logger;
    signer;
    dataNodeClient;
    constructor(logger, signer, dataNodeClient) {
        this.logger = logger;
        this.signer = signer;
        this.dataNodeClient = dataNodeClient;
    }
    async issue(recipient, attestation) {
        const userId = (0, make_user_id_1.makeUserId)(recipient);
        this.logger.debug(`Attesting '${attestation.data.type}' for userId ${userId}`);
        const signed = this.signer.sign(attestation);
        const chunk = data_chunk_codec_1.entityDataChunkCodec.toChunk(recipient, signed, protocol_core_1.Attestation);
        const res = await this.dataNodeClient.callEndpoint('storeUserDataChunk', {
            userId,
            chunk: {
                content: chunk.content,
                tags: {
                    type: attestation.data.type,
                    nonce: attestation.nonce, // for debug lookup purposes
                    ...chunk.tags,
                },
            },
        });
        return { ...res, signature: signed.signature };
    }
}
exports.AttestationIssuer = AttestationIssuer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0ZXN0YXRpb24taXNzdWVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2F0dGVzdGF0aW9uL2F0dGVzdGF0aW9uLWlzc3Vlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx3REFBa0Q7QUFLbEQsZ0VBQWdFO0FBRWhFLGlEQUEyQztBQUUzQzs7R0FFRztBQUNILE1BQWEsaUJBQWlCO0lBRVQ7SUFDQTtJQUNBO0lBSG5CLFlBQ21CLE1BQWMsRUFDZCxNQUFjLEVBQ2QsY0FBeUQ7UUFGekQsV0FBTSxHQUFOLE1BQU0sQ0FBUTtRQUNkLFdBQU0sR0FBTixNQUFNLENBQVE7UUFDZCxtQkFBYyxHQUFkLGNBQWMsQ0FBMkM7SUFDekUsQ0FBQztJQUVKLEtBQUssQ0FBQyxLQUFLLENBQUMsU0FBb0IsRUFBRSxXQUF3QjtRQUN4RCxNQUFNLE1BQU0sR0FBRyxJQUFBLHlCQUFVLEVBQUMsU0FBUyxDQUFDLENBQUE7UUFDcEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsY0FBYyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksZ0JBQWdCLE1BQU0sRUFBRSxDQUFDLENBQUE7UUFFOUUsTUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUE7UUFDNUMsTUFBTSxLQUFLLEdBQUcsdUNBQW9CLENBQUMsT0FBTyxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsMkJBQVcsQ0FBQyxDQUFBO1FBRTFFLE1BQU0sR0FBRyxHQUFHLE1BQU0sSUFBSSxDQUFDLGNBQWMsQ0FBQyxZQUFZLENBQUMsb0JBQW9CLEVBQUU7WUFDdkUsTUFBTTtZQUNOLEtBQUssRUFBRTtnQkFDTCxPQUFPLEVBQUUsS0FBSyxDQUFDLE9BQU87Z0JBQ3RCLElBQUksRUFBRTtvQkFDSixJQUFJLEVBQUUsV0FBVyxDQUFDLElBQUksQ0FBQyxJQUFJO29CQUMzQixLQUFLLEVBQUUsV0FBVyxDQUFDLEtBQUssRUFBRSw0QkFBNEI7b0JBQ3RELEdBQUcsS0FBSyxDQUFDLElBQUk7aUJBQ2Q7YUFDRjtTQUNGLENBQUMsQ0FBQTtRQUVGLE9BQU8sRUFBRSxHQUFHLEdBQUcsRUFBRSxTQUFTLEVBQUUsTUFBTSxDQUFDLFNBQVMsRUFBRSxDQUFBO0lBQ2hELENBQUM7Q0FDRjtBQTVCRCw4Q0E0QkMifQ==